import axios from 'axios'
import config from '@/api/config'
//下载导出文件专用

 /**
  * dw扫码订单
  * 订单明细
  * 导出
  * @time 2022年3月8日 周二 下午2点54分
  * */
 export const getDwFlowDetailsExportUpcFn = params =>
 axios({
   url: config.baseURL+'/snhZdwScancodeOrder/getDwFlowDetailsExportFn',
   responseType: 'blob',
   headers:{"token":localStorage.token},
   params
 })
 
 /**
  * 综合商户
  * 订单
  * 报表All
  * @time 2022年11月22日 周二 上午11点50分
  * */
  export const getYdReportFormAllExport = params =>
  axios({
    url: config.baseURL+'/snhOrder/getReportFormALL',
    responseType: 'blob',
    headers:{"token":localStorage.token},
    params
  })
  
/**
 * 综合商户
 * 订单
 * 报表
 * @time 2021年10月20日 周三 上午10点22分
 * */
 export const getYdReportFormOneExport = params =>
 axios({
   url: config.baseURL+'/snhOrder/getReportFormOne',
   responseType: 'blob',
   headers:{"token":localStorage.token},
   params
 })
 
/**
 * 银达
 * 综合商户
 * 白名单模版下载
 * @author 黄开亮
 * @date 2020年12月16日 21点16分
 */
export const getSnhMerchantWhiteListDownload = params =>
axios({
  url: config.baseURL+'/snhMerchantWhiteList/download',
  responseType: 'blob',
  headers:{"token":localStorage.token},
  params
})

/**
 * 银达
 * 农行食堂用户
 * 交易流水导出
 * @author 黄开亮
 * @date 2020年12月16日 21点16分
 */
export const getNhTransactionFlowListExport = params =>
axios({
  url: config.baseURL+'/nhTransactionFlow/getNhTransactionFlowListExport',
  responseType: 'blob',
  headers:{"token":localStorage.token},
  params
})


/**
 * 银达
 * 农行食堂用户
 * 人脸识别日志导出
 * @author 黄开亮
 * @date 2020年12月16日 21点16分
 */
export const getListnhFaceRecognitionExport = params =>
axios({
  url: config.baseURL+'/nhFaceRecognitionRecord/getListnhFaceRecognitionExport',
  responseType: 'blob',
  headers:{"token":localStorage.token},
  params
})


/**
 * 银达
 * 日志与流水对比某一天
 * 差异数据
 * @author 黄开亮
 * @date 2020年12月10日 19点56分
 */
export const journalAndRunningWaterCa = params =>
axios({
  url: config.baseURL+'/nhFaceRecognitionRecord/journalAndRunningWaterCa',
  responseType: 'blob',
  headers:{"token":localStorage.token},
  params
})

/**
 * 银达
 * 日志与流水对比某一天
 * 差异数据
 * 时间选择
 * @author 黄开亮
 * @date 2020年12月10日 19点56分
 */
export const journalAndRunningWaterCaTime = params =>
axios({
  url: config.baseURL+'/nhFaceRecognitionRecord/journalAndRunningWaterCaTime',
  responseType: 'blob',
  headers:{"token":localStorage.token},
  params
})


/**
 * 银达
 * 日志与流水对比某一天
 * 用作流水反补刷脸记录
 * 差异数据
 * -- 流水反补刷脸记录
 * 时间选择
 * @author 黄开亮
 * @date 2020年12月10日 19点56分
 */
export const journalAndRunningWaterCaSupplementaryIdentificationRecordTime = params =>
axios({
  url: config.baseURL+'/nhFaceRecognitionRecord/journalAndRunningWaterCaSupplementaryIdentificationRecordTime',
  responseType: 'blob',
  headers:{"token":localStorage.token},
  params
})


/**
 * 银达
 * 日志与流水对比某一天
 * 时间选择流水逆踢刷脸记录
 * 差异数据
 * -- 用作流水逆踢刷脸记录
 * 时间选择
 * @author 黄开亮
 * @date 2020年12月21日 17点38分
 */
export const journalAndRunningWaterCaSupplementaryIdentificationRecordKickBackTime = params =>
axios({
  url: config.baseURL+'/nhFaceRecognitionRecord/journalAndRunningWaterCaSupplementaryIdentificationRecordKickBackTime',
  responseType: 'blob',
  headers:{"token":localStorage.token},
  params
})